/**
 * PURPOSE: Renderizar la identidad de un equipo dentro del scoreboard HDMI de Handball.
 * RESPONSIBILITIES:
 *  - Sí: mostrar logo institucional en proporción rectangular 1.775:1 y abreviatura grande.
 *  - Sí: aplicar fallback visual si el logo no existe o falla.
 *  - No: no muestra nombre largo, no muestra score y no conoce BroadcastChannel.
 * COLLABORATORS:
 *  - HandballScoreboardView.jsx
 * NOTES: El scoreboard prioriza lectura pública de TV: bandera/logo + abreviatura, sin cargar la pantalla.
 * ROUTE: src/components/FullScreenModal/FullScreenPlanilla/Handball/components/scoreboard/HandballScoreboardTeamPanel.jsx
 */

import React, { useState } from "react";

// Panel visual superior de un equipo: logo rectangular tipo bandera + abreviatura.
const HandballScoreboardTeamPanel = ({ team, align = "left" }) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const isRight = align === "right";
  const code = String(team?.code || "EQ").trim().toUpperCase() || "EQ";
  const showLogo = Boolean(team?.logoUrl) && !logoFailed;

  return (
    <section className="relative flex h-full min-w-0 items-center justify-center overflow-hidden rounded-[1.6rem] border border-white/10 bg-white/[0.05] px-5 py-4 shadow-2xl backdrop-blur">
      <div
        className={`absolute top-4 z-10 rounded-xl border border-white/10 bg-black/70 px-4 py-2 text-3xl font-black uppercase leading-none tracking-tight text-white shadow-2xl xl:text-4xl ${
          isRight ? "right-4" : "left-4"
        }`}
      >
        {code.slice(0, 5)}
      </div>

      <div className="flex h-full w-full max-w-[35rem] items-center justify-center">
        <div className="flex aspect-[1.775/1] h-[82%] max-h-[14.5rem] w-full items-center justify-center overflow-hidden rounded-[0.85rem] border border-white/10 bg-white/[0.03] shadow-[0_20px_60px_rgba(0,0,0,0.28)] xl:max-h-[16.5rem] 2xl:max-h-[18rem]">
          {showLogo ? (
            <img
              src={team.logoUrl}
              alt={`Logo ${code}`}
              className="h-full w-full object-contain p-2"
              onError={() => setLogoFailed(true)}
            />
          ) : (
            <span className="px-4 text-center text-7xl font-black tracking-tight text-white xl:text-8xl 2xl:text-9xl">
              {code.slice(0, 4)}
            </span>
          )}
        </div>
      </div>
    </section>
  );
};

export default HandballScoreboardTeamPanel;
